import React, { useState, useEffect } from 'react';
import { TextInput, CheckboxInput, TextArea, DateInput } from './inputs';
import { Signature } from './../../input-types';
import { BASE_URL } from '../../../../constants';
import axios from 'axios';
import { ToastContainer } from 'react-toastr';

let container;

axios.defaults.xsrfCookieName = 'CSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-CSRF-Token';
axios.defaults.withCredentials = true;

const FormTemplate = ({
  formData,
  docName,
  docId,
  docType,
  currentUserId,
  currentUser,
}) => {
  const [inputValues, setInputValues] = useState([]);
  // const formName = document.getElementById('html-form-viewer').dataset.docName;
  // const companyDocumentId = document.getElementById('html-form-viewer').dataset.docId;
  // const docSubmissionId = document.getElementById('html-form-viewer').dataset
  //   .docSubmissionId;
  console.log(formData);

  useEffect(() => {
    let fields = [];
    formData.map((input, i) => {
      input.field_type === 'checkbox' &&
        fields.push({ id: input.id, value: input.value });
      input.field_type === 'textarea' &&
        fields.push({ id: input.id, value: input.value });
      input.field_type === 'text' &&
        fields.push({ id: input.id, value: input.value });
      input.field_type === 'date' &&
        fields.push({ id: input.id, value: input.value });
    });
    setInputValues(fields);
  }, [formData]);

  const handleOnChange = (value, input) => {
    setInputValues(
      inputValues
        .filter((ele) => ele.id !== input.id)
        .concat([{ id: input.id, value: value }])
    );
  };

  const handleSubmit = () => {
    const url = `${BASE_URL}/api/v1/company_documents/${docId}/document_form_submissions`;
    axios
      .post(url, { document_form_fields: inputValues })
      .then((res) => {
        container.success(`Form has been submitted successfully!`, ``, {
          closeButton: true,
        });
        window.location = `${BASE_URL}`;
      })
      .catch((error) => {
        container.error(error.message, ``, {
          closeButton: true,
        });
      });
  };

  return (
    <div className='form-container'>
      <ToastContainer
        ref={(ref) => (container = ref)}
        className='toast-top-right'
      />
      {formData &&
        formData.map((input, i) => (
          <div key={i} className='input-row-container'>
            <div className='input-label-container'>
              <span style={{ fontWeight: 'bold' }}>{input.field_name}:</span>
              <span style={{ fontSize: 12 }}>
                {input.description && input.description}
              </span>
            </div>
            <div className='input-container'>
              {input.field_type === 'text' ? (
                <TextInput
                  input={input}
                  inputValues={inputValues}
                  setInputValues={setInputValues}
                />
              ) : input.field_type === 'textarea' ? (
                <TextArea
                  input={input}
                  inputValues={inputValues}
                  setInputValues={setInputValues}
                />
              ) : input.field_type === 'date' ? (
                <DateInput
                  input={input}
                  inputValues={inputValues}
                  setInputValues={setInputValues}
                />
              ) : input.field_type === 'checkbox' ? (
                <CheckboxInput
                  input={input}
                  inputValues={inputValues}
                  setInputValues={setInputValues}
                />
              ) : input.field_type === 'signature' ? (
                <Signature
                  input={input}
                  inputValues={inputValues}
                  setInputValues={setInputValues}
                  currentUserId={currentUserId}
                  currentUser={currentUser}
                  formType={"form"}
                />
              ) : (
                <div></div>
              )}
            </div>
          </div>
        ))}
        {
          docType !== "TemplateForm" ? (
            <div className='input-row-container justify-content-end p-4'>
            <button className='btn btn-primary' onClick={handleSubmit}>
              Submit
            </button>
          </div>
          ) : null
        }
    </div>
  );
};

export default FormTemplate;
